import type { ResearchTypeRow } from '../../api/types';

interface ResearchTypeTableProps {
  types: ResearchTypeRow[];
  selected: number[];
  onToggle: (resTypeId: number) => void;
}

export function ResearchTypeTable({ types, selected, onToggle }: ResearchTypeTableProps) {
  if (types.length === 0) {
    return <p className="table-empty">Loading the research categories…</p>;
  }

  return (
    <div className="table-scroll">
      <table className="data-table">
        <caption className="sr-only">
          Type of research project — select all that apply
        </caption>
        <thead>
          <tr>
            <th scope="col" className="col-sr">
              Sr
            </th>
            <th scope="col" className="col-select">
              Select
            </th>
            <th scope="col">Description</th>
          </tr>
        </thead>
        <tbody>
          {types.map((type, index) => {
            const id = `ptype-${type.ResTypeId}`;
            return (
              <tr key={type.ResTypeId}>
                <td className="col-sr">{index + 1}</td>
                <td className="col-select">
                  <input
                    id={id}
                    type="checkbox"
                    checked={selected.includes(type.ResTypeId)}
                    onChange={() => onToggle(type.ResTypeId)}
                    style={{ width: 16, height: 16, accentColor: 'var(--blue-700)' }}
                  />
                </td>
                <td>
                  <label htmlFor={id} style={{ cursor: 'pointer', display: 'block' }}>
                    {type.Description}
                  </label>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
